import React, { useState } from "react";

function ReservationTab({ setReservationType }) {
  const [active, setActive] = useState(
    localStorage.getItem("reservationType") || "car"
  );

  return (
    <div className="d-flex justify-content-end">
      <div
        className="bg-dark p-2 text-white fw-bold d-flex gap-2"
        style={{ borderRadius: "10px" }}
      >
        <span
          className={`py-1 px-3 ${active === "car" ? "bg-info" : ""}`}
          style={{ cursor: "pointer", borderRadius: "7px", fontSize: "14px" }}
          onClick={() => {
            setReservationType("car");
            localStorage.setItem("reservationType", "car");
            setActive("car");
          }}
        >
          Cars
        </span>

        <span
          className={`py-1 px-3 ${active === "room" ? "bg-info" : ""}`}
          style={{ cursor: "pointer", borderRadius: "7px", fontSize: "14px" }}
          onClick={() => {
            setReservationType("room");
            localStorage.setItem("reservationType", "room");
            setActive("room");
          }}
        >
          Rooms
        </span>
      </div>
    </div>
  );
}

export default ReservationTab;
